import { memo, useCallback, type ChangeEvent } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import type { FormFieldBaseProps } from './field-base';

export interface NumberFieldProps extends FormFieldBaseProps<number | null | undefined> {}

export const NumberField = memo(function NumberField({
  field,
  value,
  onChange,
  readOnly = false,
  error,
}: NumberFieldProps) {
  const { theme } = useTheme();

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value;
      if (raw === '') {
        onChange(null);
        return;
      }
      const parsed = Number(raw);
      onChange(Number.isNaN(parsed) ? null : parsed);
    },
    [onChange],
  );

  const errorId = error ? `${field.key}__error` : undefined;
  return (
    <div className={'form-group number-field' + (theme ? ' ' + theme : '') + (error ? ' has-error' : '')}>
      <label className={'field-label' + (field.required ? ' required' : '')} htmlFor={field.key}>
        {field.label}
      </label>
      <input
        id={field.key}
        name={field.key}
        type="number"
        className={'kstc-input form-input' + (error ? ' form-input--error' : '')}
        value={value == null ? '' : String(value)}
        onChange={handleChange}
        disabled={readOnly}
        required={field.required === true}
        title={error || undefined}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
      />
      {error ? <div id={errorId} className="form-field-error" role="alert">{error}</div> : null}
    </div>
  );
});
